/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { AvaGetPrimaryProductInterestEntity } from '../actions/DataServiceEntities.g';

export interface IBusinessSignUpDropdownProps {
    id: string;
    value: string;
    dropdownOptions: AvaGetPrimaryProductInterestEntity[];
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
    resources: any;
}

export const BusinessSignUpDropdown: React.FC<IBusinessSignUpDropdownProps> = props => {
    const { value, dropdownOptions, onChange, id, resources } = props;
    return (
        <select id={id} value={value} className='msc-address-form__dropdown' onChange={onChange} name='business-sign-up-dropdown'>
            <option value='' disabled>
                {resources.primaryProductInterestPlaceholder}
            </option>
            {dropdownOptions &&
                dropdownOptions.map((element, index) => {
                    return (
                        <option value={element.primaryProductInterest} key={index}>
                            {element.primaryProductInterest}
                        </option>
                    );
                })}
        </select>
        // <div className={className}>
        //     <input type='radio' id={id} name={name} value={value} defaultChecked={value === 'Yes'} onChange={onChange} key={id} />
        //     <label htmlFor={id}>{label}</label>
        // </div>
    );
};

export default BusinessSignUpDropdown;
